import { render, staticRenderFns } from "./ExpiryTemplate.vue?vue&type=template&id=e954443c&"
import script from "./ExpiryTemplate.vue?vue&type=script&lang=js&"
export * from "./ExpiryTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ExpiryTemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports